// app/providers.jsx
'use client';

import { c as _c } from "react/compiler-runtime";
import { platform } from '@todesktop/client-core';
import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { useEffect } from 'react';
import { SESSION_REPLAY_MASKING } from './session-replay-masking';
import { POSTHOG_BEFORE_SEND } from '@/lib/analytics/posthog-client-filters';
import { Env, isDevelopment } from '@/lib/env';
export function PostHogProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp2, t1);
  let t2;
  if ($[1] !== children) {
    t2 = <PHProvider client={posthog} data-posthog-provider="true">{children}</PHProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp2() {
  if (posthog.__loaded) {
    return;
  }
  if (!Env.NEXT_PUBLIC_POSTHOG_KEY) {
    console.warn("No PostHog key found");
    return;
  }
  const tracingHeaderHosts = [window.location.host].filter(_temp);
  posthog.init(Env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: "/ingest",
    ui_host: "https://eu.posthog.com",
    defaults: "2025-05-24",
    capture_pageview: false,
    capture_pageleave: true,
    disable_session_recording: isDevelopment(),
    person_profiles: "always",
    debug: false,
    before_send: POSTHOG_BEFORE_SEND,
    session_recording: SESSION_REPLAY_MASKING,
    __add_tracing_headers: tracingHeaderHosts
  });
  if (platform.todesktop.isDesktopApp()) {
    posthog.register({
      client: "desktop"
    });
  }
}
function _temp(host) {
  return host.length > 0;
}